import {
  Button,
  Radio,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Table,
  Image,
  Select,
  DatePicker,
  Spin,
} from "antd";
import { useEffect, useState } from "react";
import plus from "../../assets/plus_icon.png";
import * as Constants from "../../constants/constants";
import "./CustomerProfile.scss";
import moment from "moment";

var axios = require("axios");
const { Option } = Select;

const CustomerProfile = (props: { location: { state?: any } }) => {
  const [transactionsArray, setTransactionsArray] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({
    firstName: "",
    lastName: "",
    dob: "",
    gender: "",
    mobile: "",
    govId: "",
    maritalStatus: "",
    imageId: "",
    city: "",
    roadName: "",
    bkash_id: "",
    bankAccountNumber: "",
    bankName: "",
    branchCode: "",
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [receiptItemsArray, setReceiptItemsArray] = useState([]);
  const [receiptDetails, setReceiptDetails] = useState({
    number: "",
    billing_time: "",
    store: "",
    amount: "",
  });
  const [openSurveyModal, setOpenSurveyModal] = useState(false);
  const [countryArray, setCountryArray] = useState<any[]>([]);
  const [bankyArray, setbankyArray] = useState<any[]>([]);
  const [surveyQuestionsArray, setsurveyQuestionsArray] = useState<any[]>([]);
  const [openActivateRegisteredUserModal, setopenActivateRegisteredUserModal] =
    useState(false);
  const [surveyAnswersSelected, setsurveyAnswersSelected] = useState<any>({
    questionone: "",
    questiontwo: "",
    questionthree: "",
    questionfour: "",
    questionfive: "",
  });
  const [userImageURL, setUserImageURL] = useState("");
  const [receiptImageUrl, setReceiptImageUrl] = useState("");
  const [surveyResults, setsurveyResults] = useState([]);
  const [govornmentID, setgovornmentID] = useState("");
  const [govornmentIDError, setgovornmentIDError] = useState(false);
  const [disableActivateBtn, setDisableActivateBtn] = useState(true);
  const [scoreValue, setscoreValue] = useState("");
  const [disableGovornmentID, setdisableGovornmentID] = useState(true);
  const [disableNextBtn, setddisableNextBtn] = useState(true);
  const [isToastVisible, setisToastVisible] = useState(false);
  const [toastText, setToastText] = useState("");
  const [userSuspiciousStatus, setUserSuspiciousStatus] = useState(false);
  const [showLoading, setshowLoading] = useState(false);
  const [bkashIDStatus, setBkashIDStatus] = useState(false);
  const ALPHA_REGREX = /^[a-zA-Z _]+$/

  const cols = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Item code",
      dataIndex: "item_code",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Quantity",
      dataIndex: "qty",
    },
    {
      title: "Rate",
      dataIndex: "rate",
    },
    {
      title: "Discount",
      dataIndex: "discount",
    },
    {
      title: "Value",
      dataIndex: "value",
    },
  ];

  const [isUserApproved, setisUserApproved] = useState(true);
  const [isUserReject, setisUserReject] = useState(false);

  const mobileNumber =
    props.location.state.mobile !== ""
      ? parseInt(props.location.state.mobile)
      : null;
  const govID =
    props.location.state.id !== "" ? parseInt(props.location.state.id) : null;

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const takeSurveyandActivate = () => {
    setOpenSurveyModal(true);
  };
  const handleSurveyModalOk = () => {
    setOpenSurveyModal(false);
  };
  const handleSurveyModalCancel = () => {
    setOpenSurveyModal(false);
  };

  const handleOkToast = () => {
    setisToastVisible(false);
  };
  const cancelToast = () => {
    setisToastVisible(false);
  };

  const handleCustomerDetailsChange =
    (name: string) => (event: { target: { value: any } }) => {
      setCustomerDetails({ ...customerDetails, [name]: event.target.value });
    };

  const handleBkashIDChange =
    (name: string) => (event: { target: { value: any } }) => {
      let val = event.target.value
      const bkashIDFormat = /^[0-9\b]+$/;
      if (bkashIDFormat.test(val) && val.length <= 11) {
        setCustomerDetails({ ...customerDetails, [name]: event.target.value });
      } else if (val.length === 0) {
        setCustomerDetails({ ...customerDetails, [name]: event.target.value });
      }
    };

    function Validate(customerDetails: any) {
      if (
        customerDetails.firstName.trim() !== "" &&
        customerDetails.firstName.match(ALPHA_REGREX)
      ) {
        if (
          (customerDetails.lastName.trim() !== "" &&
          customerDetails.lastName.match(ALPHA_REGREX)) || customerDetails.lastName === ""
        ) {
        if (customerDetails.dateOfBirth !== "") {
          if (
            (customerDetails.bankAccountNumber &&
              /^\d+$/.test(customerDetails.bankAccountNumber)) ||
            customerDetails.bankAccountNumber === ""
          ) {
            return true;
            } else {
              setToastText("Bank Account number should contain only numbers");
              setisToastVisible(true);
              return false;
            }
          } else {
            setToastText("Date of birth cannot be empty");
            setisToastVisible(true);
            return false;
          }
        } else {
          setToastText("Please enter proper lastName");
          setisToastVisible(true);
          return false;
        }
      } else {
        setToastText("Please enter proper firstname");
        setisToastVisible(true);
        return false;
      }
    }


  const nextSubmitSurvey = () => {
    setOpenSurveyModal(false);
    setopenActivateRegisteredUserModal(true);
    const surveyObj: any = [];
    surveyQuestionsArray.forEach((item, index) => {
      const question = item.question;
      const key = Constants.SURVEY_CUSTOM_FIELD_NAMES[index];
      surveyObj.push({
        name: key,
        value: question + "[Answer:" + surveyAnswersSelected[key] + "]",
      });
    });

    setsurveyResults(surveyObj);

    const token = localStorage.getItem("BASIC_TOKEN");
    const user_mobile = customerDetails.mobile;
    var config = {
      method: "get",
      url:
        `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "customer/get?mobile=" +
        user_mobile +
        "&format=json",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response: any) => {
        if (response.data.response.status.code === 200) {
          const customerInfo = response.data.response.customers.customer[0];
          for (let i = 0; i < customerInfo.custom_fields.field.length; i++) {
            if (
              customerInfo.custom_fields.field[i].name === "rejecteddate" &&
              (customerInfo.custom_fields.field[i].value !== "" ||
                customerInfo.custom_fields.field[i].value !== null)
            ) {
            }

            if (
              customerInfo.custom_fields.field[i].name === "imageid" &&
              (customerInfo.custom_fields.field[i].value !== "" ||
                customerInfo.custom_fields.field[i].value !== null)
            ) {
              getImageUrl(customerInfo.custom_fields.field[i].value);
            }
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const activateRegisteredModalModalCancel = () => {
    setopenActivateRegisteredUserModal(false);
  };

  const approveRegisteredModalModalOk = () => {
    setopenActivateRegisteredUserModal(false);
  };

  const ApproveRegisteredUser = () => {
    const surveyObj: any = [...surveyResults];
    surveyObj.push({ name: "score", value: scoreValue });
    surveyObj.push({
      name: "approveddate",
      value: moment().format("YYYY-MM-DD+HH:mm:ss"),
    });
    setsurveyResults(surveyObj);

    var dataObject = {
      mobile: customerDetails.mobile,
      external_id: govornmentID,
      custom_fields: {
        field: surveyObj,
      },
    };
    const customerObject = {
      root: {
        customer: [dataObject],
      },
    };
    const token = localStorage.getItem("BASIC_TOKEN");
    const user_mobile = customerDetails.mobile;
    var config = {
      method: "get",
      url:
        `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "customer/get?mobile=" +
        user_mobile +
        "&format=json",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        let activateBool = false;
        if (response.data.response.status.code === 200) {
          var externalId =
            response.data.response.customers.customer[0].external_id;
          var customerData =
            response.data.response.customers.customer[0].custom_fields.field;
          var approvedObj = customerData.find(
            (element: any) => element.name === "approveddate"
          );
          var rejectedObj = customerData.find(
            (element: any) => element.name === "rejecteddate"
          );
          if (externalId === govornmentID) {
            setToastText(
              "Duplicate Government ID', 'Government ID already exists."
            );
            setisToastVisible(true);
          }

          if (approvedObj === undefined || rejectedObj === undefined) {
            activateBool = true;
          } else {
            activateBool = false;
            setopenActivateRegisteredUserModal(false);
          }
          if (activateBool) {
            setopenActivateRegisteredUserModal(false);
            var config = {
              method: "post",
              url:
                `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}customer/update?format=json`,
              data: customerObject,
              headers: {
                Authorization: "Basic " + token,
                "Content-Type": "application/json",
              },
            };
            axios(config)
              .then((response: any) => {
                if (response.data.response.status.code === 200) {
                  setToastText("Activated customer successfully");
                  setisToastVisible(true);
                  getCustomerApprovedStatus(mobileNumber);
                } else {
                  setToastText(
                    "Something went wrong!!, Unable to update customer details."
                  );
                  setisToastVisible(true);
                }
              })
              .catch((error: any) => {
                setToastText(
                  "Something went wrong!!, Unable to update customer details."
                );
                setisToastVisible(true);
              });
          }
        }
      })
      .catch((error: any) => {
        setToastText("Something went wrong!!, Please try again.");
        setisToastVisible(true);
      });
  };

  const RejectRegisteredUser = () => {
    const surveyObj: any = [...surveyResults];
    surveyObj.push({ name: "score", value: scoreValue });
    surveyObj.push({
      name: "rejecteddate",
      value: moment().format("YYYY-MM-DD+HH:mm:ss"),
    });
    setsurveyResults(surveyObj);
    var dataObject = {
      mobile: customerDetails.mobile,
      custom_fields: {
        field: surveyObj,
      },
    };
    const customerObject = {
      root: {
        customer: [dataObject],
      },
    };
    const token = localStorage.getItem("BASIC_TOKEN");
    const user_mobile = customerDetails.mobile;
    var config = {
      method: "get",
      url:
        `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "customer/get?mobile=" +
        user_mobile +
        "&format=json",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        let activateBool = false;
        if (response.data.response.status.code === 200) {
          var customerData =
            response.data.response.customers.customer[0].custom_fields.field;
          var approvedObj = customerData.find(
            (element: any) => element.name === "approveddate"
          );
          var rejectedObj = customerData.find(
            (element: any) => element.name === "rejecteddate"
          );

          if (approvedObj === undefined || rejectedObj === undefined) {
            activateBool = true;
          } else {
            activateBool = false;
            setopenActivateRegisteredUserModal(false);
          }
          if (activateBool) {
            setopenActivateRegisteredUserModal(false);
            var config = {
              method: "post",
              url:
                `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}customer/update?format=json`,
              data: customerObject,
              headers: {
                Authorization: "Basic " + token,
                "Content-Type": "application/json",
              },
            };

            axios(config)
              .then((response: any) => {
                if (response.data.response.status.code === 200) {
                  setToastText("Rejected customer successfully");
                  setisToastVisible(true);
                } else {
                  setToastText(
                    "Something went wrong!!, Unable to update customer details."
                  );
                  setisToastVisible(true);
                }
              })
              .catch((error: any) => {
                setToastText(
                  "Something went wrong!!, Unable to update customer details."
                );
                setisToastVisible(true);
              });
          }
        }
      })
      .catch((error: any) => {
        setToastText("Something went wrong!!, Please try again.");
        setisToastVisible(true);
      });
  };

  const showReceiptDetailsAction = (id: any) => {
    const token = localStorage.getItem("BASIC_TOKEN");
    var config = {
      method: "get",
      url:
        `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "transaction/get?id=" +
        id +
        "&format=json",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.data.response.status.code === 200) {
          setReceiptItemsArray(
            response.data.response.transactions.transaction[0].line_items
              .line_item
          );
          setReceiptDetails(response.data.response.transactions.transaction[0]);
          const customFieldsArray =
            response.data.response.transactions.transaction[0].custom_fields
              .field;
          if (customFieldsArray.length > 0) {
            for (let i = 0; i < customFieldsArray.length; i++) {
              if (customFieldsArray[i].name === "invoice_resource_id") {
                getReceiptImageUrl(customFieldsArray[i].value);
              }
            }
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getReceiptImageUrl = (image_id: any) => {
    const token = localStorage.getItem("BASIC_TOKEN");
    var config = {
      method: "get",
      url:
        process.env.REACT_APP_GET_USER_IMAGE_URL +
        image_id +
        "?orgName=" +
        process.env.REACT_APP_USER_IMAGE_ORG_NAME +
        "&orgId=null",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response: any) => {
        if (response.data.status.code === 200) {
          const image_path = response.data.data;
          setReceiptImageUrl(image_path);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };
  const getImageUrl = (image_id: any) => {
    const token = localStorage.getItem("BASIC_TOKEN");
    var config = {
      method: "get",
      url:
        process.env.REACT_APP_GET_USER_IMAGE_URL +
        image_id +
        "?orgName=" +
        process.env.REACT_APP_USER_IMAGE_ORG_NAME +
        "&orgId=null",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response: any) => {
        if (response.data.status.code === 200) {
          const image_path = response.data.data;
          setUserImageURL(image_path);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("BASIC_TOKEN");
    const url =
      mobileNumber !== null
        ? `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "customer/transactions?format=json&mobile=" +
        mobileNumber +
        "&limit=20&offset=0"
        : govID !== null
          ? `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
          "customer/get?external_id=" +
          govID +
          "&format=json"
          : null;

    var config = {
      method: "get",
      url: url,
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.status === 200) {
          if (govID) {
            const transactions =
              response.data.response.customers.customer[0].transactions
                .transaction;
            setTransactionsArray(transactions);
          } else if (mobileNumber) {
            const transactions =
              response.data.response.customer.transactions.transaction;
            setTransactionsArray(transactions);
          } else {
            setTransactionsArray([]);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });

    getCustomerApprovedStatus(mobileNumber);
    getCountryList();
    getBankList();
  }, [mobileNumber, govID]);

  useEffect(() => {
    const token = localStorage.getItem("BASIC_TOKEN");

    const url =
      mobileNumber !== null
        ? `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "customer/get?mobile=" +
        mobileNumber +
        "&format=json"
        : govID !== null
          ? `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
          "customer/get?external_id=" +
          govID +
          "&format=json"
          : null;
    var config = {
      method: "get",
      url: url,
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };

    const orgID = localStorage.getItem("ORG_ID");
    let COUNTRIES = localStorage.getItem("COUNTRY_LIST");
    let BrandName = "";
    if (COUNTRIES) {
      let ORG_NAME = JSON.parse(COUNTRIES).find((element: any) => {
        console.log("Country ->",element);
        return element.orgid.toString() === orgID;
      });
      BrandName = ORG_NAME ? ORG_NAME.brandname : "";
    }
    function getUserImage(image_id: any) {
      const token = localStorage.getItem("BASIC_TOKEN");
      let reqUrl;
      if (localStorage.getItem('region') === "apac2") {
        reqUrl = `${process.env.REACT_APP_APAC2_IMAGE_URL}${image_id}.png?orgName=${BrandName}&orgId=${orgID}`;
      } else {
        reqUrl = `${process.env.REACT_APP_GET_USER_IMAGE_URL}${image_id}?orgName=${BrandName}&orgId=${orgID}`;
      }

      var config = {
        method: "get",
        url: reqUrl,
        headers: {
          Authorization: "Basic " + token,
          "Content-Type": "application/json",
        },
      };
      axios(config)
        .then((response: any) => {
          if (response.data.status.code === 200) {
            const image_path = response.data.data;
            setUserImageURL(image_path);
          }
        })
        .catch((error: any) => {
          console.log(error);
        });
    }

    function getCustomerSuspiciousStatus(mobileNumber: any) {
      const token = localStorage.getItem("BASIC_TOKEN");
      // let URL = process.env.REACT_APP_PAINTERS_API + mobileNumber
      var config = {
        method: "get",
        url: process.env.REACT_APP_PAINTERS_API + mobileNumber,
        headers: {
          Authorization: "Basic " + token,
          "Content-Type": "application/json",
          "app-secret": process.env.REACT_APP_APP_SECRET,
        },
      };
      axios(config)
        .then((response: any) => {
          if (response.data.status.code === 200) {
            const user_suspicious_status =
              response.data.status.data.is_suspicious;
            setUserSuspiciousStatus(user_suspicious_status);
          }
        })
        .catch((error: any) => { });
    }

    axios(config)
      .then((response: any) => {
        if (response.status === 200) {
          if (
            response.data &&
            response.data.response &&
            response.data.response.status &&
            response.data.response.status.code === 200
          ) {
            const user = response.data.response.customers.customer[0];
            const dob = user.extended_fields.field.find(
              (o: any) => o.name === "dob"
            );
            const city = user.extended_fields.field.find(
              (o: any) => o.name === "city"
            );
            const marital_status = user.extended_fields.field.find(
              (o: any) => o.name === "marital_status"
            );

            const gender = user.extended_fields.field.find(
              (o: any) => o.name === "gender"
            );

            const road = user.custom_fields.field.find(
              (o: any) => o.name === "roadname"
            );
            const bkash_id = user.custom_fields.field.find(
              (o: any) => o.name === "bkash_id"
            );
            const bank_account_number = user.custom_fields.field.find(
              (o: any) => o.name === "bank_accnt"
            );
            const branch_code = user.custom_fields.field.find(
              (o: any) => o.name === "branch_code"
            );
            const bank_Name = user.custom_fields.field.find(
              (o: any) => o.name === "bank_branch_name"
            );
            if (typeof bkash_id !== 'undefined') {
              setBkashIDStatus(true)
            }
            setCustomerDetails((customerDetails) => ({
              ...customerDetails,
              firstName: user.firstname,
              lastName: user.lastname,
              mobile: user.mobile,
              govId: user.external_id,
              roadName: road ? road.value : "",
              gender: gender ? gender.value : undefined,
              maritalStatus: marital_status ? marital_status.value : undefined,
              dob: dob ? dob.value : "",
              city: city ? city.value : "",
              bkash_id: bkash_id ? bkash_id.value : "",
              bankAccountNumber: bank_account_number?.value ?? "",
              bankName: bank_Name?.value ?? "",
              branchCode: branch_code?.value ?? "",
            }));
            const imageId = user.custom_fields.field.find(
              (o: any) => o.name === "imageid"
            );
            if (imageId) {
              getUserImage(imageId.value);
            }
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
    getCustomerSuspiciousStatus(mobileNumber);
  }, [mobileNumber, govID]);

  const getCustomerApprovedStatus = (mobileNumber: any) => {
    const token = localStorage.getItem("BASIC_TOKEN");
    var config = {
      method: "get",
      url:
        `${localStorage.getItem('region') === "apac2" ? process.env.REACT_APP_APAC2_BASE_URL : process.env.REACT_APP_BASE_URL}` +
        "customer/get?mobile=" +
        mobileNumber +
        "&format=json",
      headers: {
        Authorization: "Basic " + token,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.status === 200) {
          if (
            response.data &&
            response.data.response &&
            response.data.response.status &&
            response.data.response.status.code === 200
          ) {
            const user = response.data.response.customers.customer[0];
            if (
              user &&
              user.custom_fields &&
              user.custom_fields.field &&
              user.custom_fields.field.length > 0
            ) {
              const approved_date = user.custom_fields.field.find(
                (o: any) => o.name === "approveddate"
              );
              const rejecteddate = user.custom_fields.field.find(
                (o: any) => o.name === "rejecteddate"
              );
              if (approved_date) {
                setisUserApproved(true);
                setisUserReject(false);
              } else if (rejecteddate) {
                setisUserReject(true);
                setisUserApproved(false);
              } else {
                setisUserApproved(false);
                setisUserReject(false);
              }
            }
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getCountryList = () => {
    var config = {
      method: "get",
      url: process.env.REACT_APP_COUNTRIES_LIST_URL,
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.status === 200) {
          const countryList = response.data.data;
          setCountryArray(countryList);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const getBankList = () => {
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_SURVEY_QUESTIONS_URL}${process.env.REACT_APP_STTARTER_DEALER_KEY}/banks`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then((response: any) => {
        if (response.status === 200) {
          setbankyArray(response.data.data);
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  const getSurveyQuestions = (sttarterappkey: any) => {
    var config = {
      method: "get",
      url:
        process.env.REACT_APP_SURVEY_QUESTIONS_URL +
        sttarterappkey +
        "/surveyquestions?orderby_asc=ordering",
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response: any) => {
        if (response.status === 200) {
          const questionsList = response.data.data;
          const surveyDetails: any = [];
          let randomItem: any;
          let found: any;
          if (questionsList.length > Constants.SHOW_NUMBER_OF_QUESTIONS) {
            for (let i = 0; i < questionsList.length; i++) {
              if (surveyDetails.length < Constants.SHOW_NUMBER_OF_QUESTIONS) {
                randomItem =
                  questionsList[
                  Math.floor(Math.random() * questionsList.length)
                  ];
                found = findQuestionExistance(surveyDetails, randomItem._id);
                if (!found) {
                  surveyDetails.push(randomItem);
                }
              }
            }
            setsurveyQuestionsArray(surveyDetails);
          } else {
            setsurveyQuestionsArray(questionsList);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  const findQuestionExistance = (surveyDetails: any, id: any) => {
    surveyDetails.some(function (el: any) {
      return el._id === id;
    });
  };

  const columns: any = [
    {
      title: "Number",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Store",
      dataIndex: "store",
      key: "store",
    },
    {
      title: "Bill Date",
      dataIndex: "billing_time",
      // key: "store",
    },
    {
      title: "Points Issued",
      dataIndex: ["points", "issued"],
      align: "center" as "center",
    },
    {
      title: "Points Returned",
      dataIndex: ["points", "returned"],
      align: "center" as "center",
    },
    {
      title: "Basket Size",
      dataIndex: "basket_size",
      align: "center" as "center",
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center" as "center",

      render: (record: any) => (
        <Row style={{ width: "105px" }}>
          <Col span={24}>
            {" "}
            <p
              className="action-icon-plus"
              onClick={() => {
                showModal();
                showReceiptDetailsAction(record);
              }}
            >
              <img src={plus} alt="" width="41" height="41" />
            </p>
          </Col>
        </Row>
      ),
    },
  ];

  const bankOptions =
    bankyArray &&
    bankyArray.map((data: any) => {
      return { value: data._id, label: data.bankname };
    });

  const handleCountySelected = (sttarterappkey: any) => {
    getSurveyQuestions(sttarterappkey);
  };
  const changeGeneder = (value: any) => {
    setCustomerDetails({ ...customerDetails, gender: value });
  };
  const changeMaritalStatus = (value: any) => {
    setCustomerDetails({ ...customerDetails, maritalStatus: value });
  };
  const changeBankDetails = (value: any) => {
    const bankData = bankyArray.find((o: any) => o._id === value);
    setCustomerDetails({
      ...customerDetails,
      bankName: bankData.bankname,
      branchCode: bankData.bankcode,
    });
  };

  const onRadioSelect = (e: any) => {
    const name = e.target.name;
    const value = e.target.value;
    setsurveyAnswersSelected((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
    setddisableNextBtn(false);
  };

  const handleCustomerUpdate = () => {
    const token = localStorage.getItem("BASIC_TOKEN");
    if (!bkashIDStatus || customerDetails.bkash_id.length === 11) {
      if (Validate(customerDetails)) {
        const customFieldsObj: any = [];
        customFieldsObj.push({
          name: "roadname",
          value: customerDetails.roadName,
        });
        customFieldsObj.push({
          name: "bank_accnt",
          value: customerDetails.bankAccountNumber,
        });
        customFieldsObj.push({
          name: "bank_branch_name",
          value: customerDetails.bankName,
        });
        customFieldsObj.push({
          name: "branch_code",
          value: customerDetails.branchCode,
        });
        if (bkashIDStatus) {
          customFieldsObj.push({
            name: "bkash_id",
            value: customerDetails.bkash_id,
          });
        }
        const extendedFieldsObj: any = [];
        extendedFieldsObj.push({
          name: "marital_status",
          value: customerDetails.maritalStatus,
        });

        extendedFieldsObj.push({ name: "dob", value: customerDetails.dob });
        extendedFieldsObj.push({ name: "gender", value: customerDetails.gender });
        extendedFieldsObj.push({ name: "city", value: customerDetails.city });


        var dataObject = {
          mobile: customerDetails.mobile,
          external_id: customerDetails.govId,
          firstname: customerDetails.firstName,
          lastname: customerDetails.lastName,
          custom_fields: {
            field: customFieldsObj,
          },
          extended_fields: {
            field: extendedFieldsObj,
          },
        };
        const customerObject = {
          root: {
            customer: [dataObject],
          },
        };
        var config = {
          method: "post",
          url:
            `${
              localStorage.getItem("region") === "apac2"
                ? process.env.REACT_APP_APAC2_BASE_URL
                : process.env.REACT_APP_BASE_URL
            }` +
            "customer/update?mobile=" +
            mobileNumber +
            "&format=json",
          headers: {
            Authorization: "Basic " + token,
            "Content-Type": "application/json",
          },
          data: customerObject,
        };
        setshowLoading(true);
        axios(config)
          .then((response: any) => {
            if (response.data.response.status.code === 200) {
              setToastText("Customer updated successfully");
              setisToastVisible(true);
              setshowLoading(false);
            } else {
              setToastText("Something went wrong!!, Please try again.");
              setisToastVisible(true);
              setshowLoading(false);
            }
          })
          .catch((error: any) => {
            setToastText("Something went wrong!!, Please try again.");
            setisToastVisible(true);
            setshowLoading(false);
          });
      }
    } else {
      alert("Please enter a valid bKash ID")
    }
  };

  const disabledDate = (current: any) => {
    return current && current > moment().endOf("day");
  };

  return (
    <div>
      <Spin tip="Loading..." spinning={showLoading}>
        <div className="customerDetailsContainer">
          <p className="title">Customer Profile</p>
          {!isUserApproved && !isUserReject && (
            <div className="pendingStatus">
              <p className="pendingStatusText">STATUS-PENDING</p>
            </div>
          )}
          {isUserReject && (
            <div className="pendingStatus">
              <p className="pendingStatusText">STATUS-REJECTED</p>
            </div>
          )}
          {isUserApproved && !isUserReject && (
            <div className="pendingStatus">
              <p className="pendingStatusText">STATUS-ACTIVE</p>
            </div>
          )}
          {userSuspiciousStatus && (
            <div className="SuspiciousStatus">
              <p className="SuspiciousStatusText">**Suspicious User</p>
            </div>
          )}

          <form>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>First Name</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.firstName ? customerDetails.firstName : ""
                    }
                    onChange={handleCustomerDetailsChange("firstName")}
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Last Name</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.lastName ? customerDetails.lastName : ""
                    }
                    onChange={handleCustomerDetailsChange("lastName")}
                  />
                </div>
              </Col>
            </div>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Date of Birth</label>
                  <DatePicker
                    placeholder=""
                    showTime
                    format="L"
                    disabledDate={disabledDate}
                    onChange={(date, dateString) => {
                      setCustomerDetails({
                        ...customerDetails,
                        dob: dateString,
                      });
                    }}
                    value={
                      customerDetails.dob ? moment(customerDetails.dob) : null
                    }
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Gender</label>
                  <Input.Group style={{ width: "100%", height: "57px" }}>
                    <Select
                      // defaultValue={"Choose"}
                      value={customerDetails.gender}
                      onChange={changeGeneder}
                      placeholder="Choose"
                    >
                      <Option value="Male">Male</Option>
                      <Option value="Female">Female</Option>
                      <Option value="Transgender">Transgender</Option>
                    </Select>
                  </Input.Group>
                </div>
              </Col>
            </div>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Mobile Number</label>
                  <Input
                    placeholder=""
                    value={customerDetails.mobile ? customerDetails.mobile : ""}
                    disabled
                  />
                </div>
              </Col>
              <Col span={11}>
                <div>
                  <label>Government ID</label>
                  <Input
                    placeholder=""
                    value={customerDetails.govId ? customerDetails.govId : ""}
                    disabled
                  />
                </div>
              </Col>
            </div>
            <div className="customer-details">
              <Col span={11}>
                <div>
                  <label>Marital Status</label>
                  {/* <Input placeholder="" value="" /> */}
                  <Input.Group
                    style={{
                      width: "100%",
                      height: "57px",
                      marginBottom: "1rem",
                    }}
                  >
                    <Select
                      showSearch
                      value={customerDetails.maritalStatus}
                      onChange={changeMaritalStatus}
                      placeholder="Choose"
                    >
                      <Option value="Single">Single</Option>
                      <Option value="Married">Married</Option>
                      <Option value="Widowed">Widowed</Option>
                      <Option value="Divorced">Divorced</Option>
                    </Select>
                  </Input.Group>
                </div>
                <div>
                  <label>City</label>
                  <Input
                    placeholder=""
                    value={customerDetails.city ? customerDetails.city : ""}
                    onChange={handleCustomerDetailsChange("city")}
                  />
                </div>
                <div>
                  <label>Road Name</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.roadName ? customerDetails.roadName : ""
                    }
                    onChange={handleCustomerDetailsChange("roadName")}
                  />
                </div>
                <div>
                  <label>Bank Account Number</label>
                  <Input
                    placeholder=""
                    value={
                      customerDetails.bankAccountNumber
                        ? customerDetails.bankAccountNumber
                        : ""
                    }
                    onChange={handleCustomerDetailsChange("bankAccountNumber")}
                  />
                </div>
                <div>
                  <label>Bank Name</label>
                  <Input.Group
                    className="selectBox"
                  >
                    <Select
                      showSearch
                      value={customerDetails.bankName}
                      onChange={changeBankDetails}
                      placeholder="Choose"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={bankOptions}
                    >
                    </Select>
                  </Input.Group>
                </div>
                <div>
                  <label>Branch code</label>
                  <Input
                    contentEditable={false}
                    placeholder=""
                    value={
                      customerDetails.branchCode
                        ? customerDetails.branchCode
                        : ""
                    }
                    disabled
                  />
                </div>
                {bkashIDStatus &&
                  <div>
                    <label>bKash ID</label>
                    <Input
                      placeholder=""
                      maxLength={11}
                      value={customerDetails.bkash_id ? customerDetails.bkash_id : ""}
                      onChange={handleBkashIDChange("bkash_id")}

                    />
                  </div>
                }
              </Col>
              <Col span={11}>
                <div className="customer-photo d-flex justify-content-center">
                  <img
                    src={userImageURL}
                    width={"100%"}
                    height={328}
                    style={{ padding: " 10px 0px" }}
                    alt=""
                  />
                  {/* <button>Change</button> */}
                </div>
              </Col>
            </div>
            <div>
              <Button
                className="saveBtn"
                type="primary"
                onClick={handleCustomerUpdate}
              >
                Save
              </Button>
              {!isUserApproved && (
                <Button
                  className="surveyBtn"
                  type="primary"
                  onClick={takeSurveyandActivate}
                >
                  Take Survey and Activate
                </Button>
              )}

              <Modal
                className="surveyModal"
                title="Customer Survey"
                onCancel={handleSurveyModalCancel}
                footer={[
                  <Button
                    type="primary"
                    onClick={nextSubmitSurvey}
                    disabled={disableNextBtn}
                    style={{
                      background: "#31A1E7",
                      borderRadius: 15,
                      width: "100px",
                      padding: 0,
                    }}
                  >
                    Next
                  </Button>,
                ]}
                visible={openSurveyModal}
                onOk={handleSurveyModalOk}
              >
                <Select
                  defaultValue="Select Country"
                  style={{ width: "100%" }}
                  onChange={handleCountySelected}
                >
                  {countryArray.map((list) => {
                    return (
                      <Option value={list.sttarterappkey}>
                        {list.displayname}
                      </Option>
                    );
                  })}
                </Select>

                {surveyQuestionsArray.map((question, index) => {
                  return (
                    <div
                      style={{
                        background: "#d9d9d9",
                        padding: 10,
                        borderRadius: 5,
                        marginBottom: 20,
                        marginTop: 20,
                      }}
                    >
                      <p style={{ color: "black" }}>
                        {index + 1} {question.question}
                      </p>
                      <Radio.Group
                        name={Constants.SURVEY_CUSTOM_FIELD_NAMES[index]}
                        onChange={onRadioSelect}
                      >
                        {question.answeroptions ? question.answeroptions.map((answers: any) => {
                          return (
                            <Radio
                              name="imeme"
                              value={answers.choiceanswer}
                              style={{ color: "#757575" }}
                            >
                              {answers.choiceanswer}
                            </Radio>
                          );
                        })
                          :
                          null
                        }
                      </Radio.Group>
                    </div>
                  );
                })}
              </Modal>

              <Modal
                className="activateModal"
                title="Activate/ Reject Customer"
                onCancel={activateRegisteredModalModalCancel}
                footer={[
                  <div className="activateModalFooter">
                    <Button
                      type="primary"
                      disabled={disableActivateBtn}
                      onClick={ApproveRegisteredUser}
                      style={{
                        background: "#40daf1",
                        borderRadius: 15,
                        border: "1px solid #40daf1",
                        color: "white !important",
                      }}
                    >
                      Activate
                    </Button>
                    <Button
                      type="primary"
                      onClick={RejectRegisteredUser}
                      style={{
                        background: "red",
                        borderRadius: 15,
                        border: "1px solid red",
                        color: "white",
                      }}
                    >
                      Reject
                    </Button>
                  </div>,
                ]}
                visible={openActivateRegisteredUserModal}
                onOk={approveRegisteredModalModalOk}
              >
                <div className="activateModalDiv">
                  <label className="activateModallabel">Score</label>
                  <Input
                    className="activateModalinput"
                    placeholder=""
                    value={scoreValue}
                    onChange={(text: any) => {
                      const val = text.target.value;
                      setscoreValue(val);
                      const isnum = /^\d+$/.test(val);
                      if (isnum) {
                        if (val < Constants.VALID_SCORE) {
                          setdisableGovornmentID(true);
                        } else {
                          setdisableGovornmentID(false);
                        }
                      } else {
                        setdisableGovornmentID(true);
                      }
                    }}
                  />
                  <label className="activateModallabel">Government ID</label>
                  <Input
                    className="activateModalinput"
                    placeholder=""
                    value={govornmentID}
                    disabled={disableGovornmentID}
                    onChange={(text: any) => {
                      const Gov_ID = text.target.value;
                      if (/^[a-zA-Z0-9]+$/.test(Gov_ID) === false) {
                        setgovornmentIDError(true);
                        if (!Gov_ID) {
                          setgovornmentID(Gov_ID);
                        }
                      } else {
                        setgovornmentIDError(false);
                        setgovornmentID(Gov_ID);
                        setDisableActivateBtn(false);
                      }
                    }}
                  />
                  {govornmentIDError ? (
                    <label className="activateModallabelError">
                      Please Enter a valid Government ID
                    </label>
                  ) : null}
                  <br />
                  <label className="activateModallabel">Government ID</label>
                  <Image
                    width={"100%"}
                    height={400}
                    style={{ padding: " 10px 0px" }}
                    src={userImageURL}
                  />
                </div>
              </Modal>
            </div>
          </form>
          <Divider></Divider>
          <p className="formTitle">Transactions</p>
          <Divider></Divider>
          {transactionsArray && (
            <Table dataSource={transactionsArray} columns={columns} />
          )}
        </div>
        <Modal
          className="receipt_detailsModal"
          title="Receipt Details"
          width={"auto"}
          onCancel={handleCancel}
          footer={null}
          visible={isModalVisible}
          onOk={handleOk}
        >
          <Row style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <Col
              span={15}
              style={{ borderRight: "1px solid #D9D3D3", paddingRight: "5px" }}
            >
              {receiptDetails && (
                <div className="receipt-details-basic">
                  <p>
                    <label
                      className="labelText"
                      style={{ color: "#417fbb", fontWeight: "500" }}
                    >
                      Number:
                    </label>{" "}
                    {receiptDetails.number}
                  </p>
                  <p>
                    <label
                      className="labelText"
                      style={{ color: "#417fbb", fontWeight: "500" }}
                    >
                      Store:
                    </label>{" "}
                    {receiptDetails.store}
                  </p>
                  <p>
                    <label
                      className="labelText"
                      style={{ color: "#417fbb", fontWeight: "500" }}
                    >
                      Billing Date:
                    </label>{" "}
                    {receiptDetails.billing_time}
                  </p>
                  <p>
                    <label
                      className="labelText"
                      style={{ color: "#417fbb", fontWeight: "500" }}
                    >
                      Amount:
                    </label>{" "}
                    {receiptDetails.amount}
                  </p>
                </div>
              )}
              <Divider></Divider>

              <label className="tableHeading">Item Details</label>

              <Table columns={cols} dataSource={receiptItemsArray} />
            </Col>
            <Col
              span={9}
              style={{
                paddingLeft: "20px",
                paddingRight: "20px",
                paddingTop: "5px",
              }}
            >
              <Image width={396} height={500} src={receiptImageUrl} />
            </Col>
          </Row>
        </Modal>
        <Modal
          title="Jotun Master Painter"
          onCancel={cancelToast}
          footer={null}
          visible={isToastVisible}
          onOk={handleOkToast}
        >
          <p>{toastText}</p>
        </Modal>
      </Spin>
    </div>
  );
};

export default CustomerProfile;
